<div class="rs-message">
  <rs-message>
    <div id="header">
      <div class="rs-message__header">{{'website.do-not-worry' | translate}}</div>
    </div>
    <div id="content">{{'website.we-have-got' | translate}}</div>
  </rs-message>
</div>
